export const LEVEL_ALERT = 'indicator_criticality_level_alert'
export const LEVEL_NORMAL = 'indicator_criticality_level_normal'
export const LEVEL_WARNING = 'indicator_criticality_level_warning'
export const LEVEL_NO_STATUS = 'indicator_criticality_level_no_status'

export const TYPE_CONTINUOUS = 'continuous'
export const TYPE_DISCRETE = 'discrete'
